var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 21.0006C42 31.6066 34.1374 40.3747 23.924 41.798C22.9687 41.931 21.9916 41.9999 21 41.9999C19.8548 41.9999 18.7314 41.908 17.6358 41.7314C7.63769 40.122 0 31.4519 0 20.9993C0 9.4017 9.40201 0 21 0C32.598 0 42 9.4017 42 20.9993V21.0006Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2773 14.5561L19.1996 20.4977C20.5626 21.5199 22.4366 21.5199 23.7996 20.4977L31.7218 14.556",
    stroke: "#051A2F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4444 12H12.5556C11.1442 12 10 13.1442 10 14.5556V27.3333C10 28.7447 11.1442 29.8889 12.5556 29.8889H30.4444C31.8558 29.8889 33 28.7447 33 27.3333V14.5556C33 13.1442 31.8558 12 30.4444 12Z",
    stroke: "#051A2F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.80f0ea5721cb5a8b65f19b0e214f0432.svg";
export { ForwardRef as ReactComponent };